import { networkService as network } from '@/services'

export const userCompanyProfilesService = {
  getUserCompanyProfilesAll (id, locale = 'en') {
    return new Promise((resolve, reject) => {
      network.get(`/company-profiles/all/${id}`).then((data) => {
        let companyProfiles = [];

        data.data.forEach((item, index) => {
          let companyProfile = item;
          let translatedData = item.translations.filter(elem => elem.locale === locale)[0];

          companyProfile.name = translatedData.name;
          companyProfile.description = translatedData.description;
          companyProfile.jobTitle = translatedData.jobTitle;

          companyProfiles.push(companyProfile);
        })

        resolve(companyProfiles)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  // Получить первую компанию в списке компаний пользователя
  getUserCompanyProfileFirst (id, locale = 'en') {
    return new Promise((resolve, reject) => {
      this.getUserCompanyProfilesAll(id, locale)
      .then((data) => {
        resolve(data[0])
      })
    })
  },

  // createUserCompany ({ user, avatarType = 0, isDisplayName = false,
  // canVisitorView = false, canCompanyView = false, canStartChat = false }) {
  // return new Promise((resolve, reject) => { const request = { user,
  // avatarType, isDisplayName, canVisitorView, canCompanyView, canStartChat, }
  // network.post(`/user-options`, request).then((data) => { resolve(data.data)
  // }).catch((err) => { reject(err) }) }) },

  updateCompanyProfile ({ id, user, sector, subSector, locale = 'en', name, description, jobTitle, logo, phone, website, country, city, zipCode, nationalIdentification, commercialRegistration }) {

    return new Promise((resolve, reject) => {
      const request = {
        id,
        user,
        sector,
        subSector,
        locale,
        name,
        description,
        jobTitle,
        logo,
        phone,
        website,
        country,
        city,
        zipCode,
        nationalIdentification,
        commercialRegistration,
      }
      network.put(`/company-profiles/${id}`, request).then((data) => {
        resolve(data.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
}
